import { render, staticRenderFns } from "./OpenIdentity.vue?vue&type=template&id=a2833e9c&scoped=true"
import script from "./OpenIdentity.vue?vue&type=script&lang=js"
export * from "./OpenIdentity.vue?vue&type=script&lang=js"
import style0 from "./OpenIdentity.vue?vue&type=style&index=0&id=a2833e9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2833e9c",
  null
  
)

export default component.exports